import {Component} from '@angular/core';
import {CrudCompaniesService} from '../../../../shared/services/crud-companies.service';
import {AbstractCrudListComponent} from '@shared/library/crud-library/abstract-crud-list.component';
import {Router} from '@angular/router';
import {IDisplayColumn} from '@shared/library/crud-library/crud-list/crud-list.component';
import {AlertService} from '@shared/services/alert.service';

@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.scss']
})
export class CompaniesListComponent extends AbstractCrudListComponent {

  constructor(router: Router, httpCrud: CrudCompaniesService, alertService: AlertService) {
    super(router, httpCrud, alertService);

    this.entityroot = '/admin/companies';

    this.editpathprefix = this.entityroot + '/';

    this.createlink = this.entityroot + '/create';

    // Set here the list of columns to display
    this.displayedcolumns = [
      {columnName: 'id', label: 'ID'},
      {columnName: 'label', label: 'Name', isKeyColumn: true},
      {columnName: 'variantlabel', label: 'Variant label'},
      {columnName: 'fullnr', label: 'Full Nr'},
      {columnName: 'add-child-button', label: ''}
    ] as IDisplayColumn[];

  }

  getNewChildLink(parentid: string) {
    const newChildLink = this.entityroot + '/create/' + parentid;
    this.router.navigate([newChildLink]);
  }
}
